import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "col-md-12 container-fluid bg-white rounded shadow mt-3 p-3 text-start py-3" }
const _hoisted_3 = {
  key: 0,
  class: "text-start"
}
const _hoisted_4 = {
  key: 1,
  class: "text-start"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-sm-6 col-md-6 mb-3 mt-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "รหัสสินค้า", -1)
const _hoisted_9 = { class: "col-sm-6 col-md-6 mb-3 mt-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "หมวดหมู่", -1)
const _hoisted_11 = { class: "col-sm-12" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { selected: "" }, "เลือก", -1)
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  class: "accordion",
  id: "accordionPanelsStayOpenExample"
}
const _hoisted_15 = { class: "accordion-item" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "panelsStayOpen-headingOne"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#panelsStayOpen-collapseOne",
    "aria-expanded": "true",
    "aria-controls": "panelsStayOpen-collapseOne"
  }, "ภาษาไทย")
], -1)
const _hoisted_17 = {
  class: "accordion-collapse collapse show",
  id: "panelsStayOpen-collapseOne",
  "aria-labelledby": "panelsStayOpen-headingOne"
}
const _hoisted_18 = { class: "accordion-body" }
const _hoisted_19 = { class: "row text-start" }
const _hoisted_20 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "ชื่อ", -1)
const _hoisted_22 = { class: "col-sm-6 col-md-6 mb-3 mt-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "วัด", -1)
const _hoisted_24 = { class: "col-sm-6 col-md-6 mb-3 mt-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "ภูมิภาค", -1)
const _hoisted_26 = { class: "col-sm-12" }
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<option selected=\"\">เลือก</option><option value=\"กรุงเทพ/ปริมณฑล\">กรุงเทพ/ปริมณฑล</option><option value=\"กลาง\">กลาง</option><option value=\"เหนือ\">เหนือ</option><option value=\"อีสาน\">อีสาน</option><option value=\"ใต้\">ใต้</option>", 6)
const _hoisted_33 = [
  _hoisted_27
]
const _hoisted_34 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "คำอธิบาย", -1)
const _hoisted_36 = { class: "accordion-item" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "panelsStayOpen-headingTwo"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#panelsStayOpen-collapseTwo",
    "aria-expanded": "false",
    "aria-controls": "panelsStayOpen-collapseTwo"
  }, "ภาษาอังกฤษ")
], -1)
const _hoisted_38 = {
  class: "accordion-collapse collapse",
  id: "panelsStayOpen-collapseTwo",
  "aria-labelledby": "panelsStayOpen-headingTwo"
}
const _hoisted_39 = { class: "accordion-body" }
const _hoisted_40 = { class: "row text-start" }
const _hoisted_41 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "ชื่อ (ภาษาอังกฤษ)", -1)
const _hoisted_43 = { class: "col-sm-6 col-md-6 mb-3 mt-3" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "วัด (ภาษาอังกฤษ)", -1)
const _hoisted_45 = { class: "col-sm-6 col-md-6 mb-3 mt-3" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "ภูมิภาค (ภาษาอังกฤษ)", -1)
const _hoisted_47 = { class: "col-sm-12" }
const _hoisted_48 = /*#__PURE__*/_createStaticVNode("<option selected=\"\">เลือก</option><option value=\"Bangkok Metropolitan Region\">กรุงเทพ/ปริมณฑล</option><option value=\"Central\">กลาง</option><option value=\"Northern\">เหนือ</option><option value=\"Northeastern\">อีสาน</option><option value=\"Southern\">ใต้</option>", 6)
const _hoisted_54 = [
  _hoisted_48
]
const _hoisted_55 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "คำอธิบาย (ภาษาอังกฤษ)", -1)
const _hoisted_57 = { class: "accordion-item" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "panelsStayOpen-headingThree"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#panelsStayOpen-collapseThree",
    "aria-expanded": "false",
    "aria-controls": "panelsStayOpen-collapseThree"
  }, "ภาษาจีน")
], -1)
const _hoisted_59 = {
  class: "accordion-collapse collapse",
  id: "panelsStayOpen-collapseThree",
  "aria-labelledby": "panelsStayOpen-headingThree"
}
const _hoisted_60 = { class: "accordion-body" }
const _hoisted_61 = { class: "row text-start" }
const _hoisted_62 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "ชื่อ (ภาษาจีน)", -1)
const _hoisted_64 = { class: "col-sm-6 col-md-6 mb-3 mt-3" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "วัด (ภาษาจีน)", -1)
const _hoisted_66 = { class: "col-sm-6 col-md-6 mb-3 mt-3" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "ภูมิภาค (ภาษาจีน)", -1)
const _hoisted_68 = { class: "col-sm-12" }
const _hoisted_69 = /*#__PURE__*/_createStaticVNode("<option selected=\"\">เลือก</option><option value=\"曼谷及其周边地区\">กรุงเทพ/ปริมณฑล</option><option value=\"中部\">กลาง</option><option value=\"北部\">เหนือ</option><option value=\"东北\">อีสาน</option><option value=\"南部\">ใต้</option>", 6)
const _hoisted_75 = [
  _hoisted_69
]
const _hoisted_76 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "คำอธิบาย (ภาษาจีน)", -1)
const _hoisted_78 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_79 = { class: "row" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "รูปภาพ", -1)
const _hoisted_81 = { class: "col-sm-12" }
const _hoisted_82 = { class: "d-flex mb-5 justify-content-center mt-3" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { class: "ms-5" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JMUploadImages = _resolveComponent("JMUploadImages")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (this.$route.params.id == undefined)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_3, "เพิ่มสินค้า"))
        : (_openBlock(), _createElementBlock("h4", _hoisted_4, "แก้ไขสินค้า ")),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.doc.code) = $event))
          }, null, 512), [
            [_vModelText, _ctx.doc.code]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.doc.category) = $event))
            }, [
              _hoisted_12,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item._id
                }, _toDisplayString(item.nameTH), 9, _hoisted_13))
              }), 256))
            ], 512), [
              [_vModelSelect, _ctx.doc.category]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.doc.nameTH) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.doc.nameTH]
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.doc.templeNameTH) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.doc.templeNameTH]
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.doc.regionTH) = $event))
                    }, _hoisted_33, 512), [
                      [_vModelSelect, _ctx.doc.regionTH]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    style: {"height":"5em"},
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.doc.descriptionTH) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.doc.descriptionTH]
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.doc.nameEN) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.doc.nameEN]
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.doc.templeNameEN) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.doc.templeNameEN]
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createElementVNode("div", _hoisted_47, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.doc.regionEN) = $event))
                    }, _hoisted_54, 512), [
                      [_vModelSelect, _ctx.doc.regionEN]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _hoisted_56,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    style: {"height":"5em"},
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.doc.descriptionEN) = $event))
                  }, "     ", 512), [
                    [_vModelText, _ctx.doc.descriptionEN]
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_57, [
          _hoisted_58,
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _hoisted_63,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.doc.nameCH) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.doc.nameCH]
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.doc.templeNameCH) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.doc.templeNameCH]
                  ])
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _hoisted_67,
                  _createElementVNode("div", _hoisted_68, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.doc.regionCH) = $event))
                    }, _hoisted_75, 512), [
                      [_vModelSelect, _ctx.doc.regionCH]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_76, [
                  _hoisted_77,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    style: {"height":"5em"},
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.doc.descriptionCH) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.doc.descriptionCH]
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _hoisted_80,
            _createElementVNode("div", _hoisted_81, [
              _createVNode(_component_JMUploadImages, {
                modelValue: _ctx.doc.images,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.doc.images) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_82, [
            _createVNode(_component_router_link, {
              class: "btn btn-dark",
              to: `/portal/product`
            }, {
              default: _withCtx(() => [
                _createTextVNode("ยกเลิก")
              ]),
              _: 1
            }),
            _hoisted_83,
            _createElementVNode("a", {
              class: "btn btn-secondary bg-secondary",
              onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)))
            }, "บันทึก")
          ])
        ])
      ])
    ])
  ]))
}